var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25196",
    "data-name": "Group 25196",
    transform: "translate(-1235.999 -321.909)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24312",
    "data-name": "Group 24312",
    transform: "translate(1241.603 327.517)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12909",
    "data-name": "Rectangle 12909",
    width: 12,
    height: 13,
    transform: "translate(0.488 -0.426)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24311",
    "data-name": "Group 24311",
    transform: "translate(1.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11997",
    "data-name": "Group 11997",
    transform: "translate(2.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11996",
    "data-name": "Group 11996",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M124.419,0a3.419,3.419,0,1,0,3.419,3.419A3.423,3.423,0,0,0,124.419,0Z",
    transform: "translate(-121)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11999",
    "data-name": "Group 11999",
    transform: "translate(0 7.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11998",
    "data-name": "Group 11998",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M40.952,301.474A4.874,4.874,0,0,0,37.458,300H35.938a4.874,4.874,0,0,0-3.494,1.474A4.982,4.982,0,0,0,31,304.989a.38.38,0,0,0,.38.38H42.016a.38.38,0,0,0,.38-.38A4.982,4.982,0,0,0,40.952,301.474Z",
    transform: "translate(-31 -300)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircle);
export default __webpack_public_path__ + "static/media/person-circle.928de459781dcdf601c64c23057603e4.svg";
export { ForwardRef as ReactComponent };